import * as routeHelpers from "../../lib/routeHelpers";
import Drawer from "../Drawer";
import ErrorModal from "../ErrorModal";
import OutlineButton from "../OutlineButton";
import React, {useContext} from "react";
import styles from "./ManagerRemoveTill.module.css";
import TextButton from "../TextButton/TextButton";
import tillIcon from "../../images/till.svg";
import {StationContext} from "../StationContext";
import {TillAssignmentContext} from "../TillAssignmentContext";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../lib/hooks";

const strings = {
    no: "No, Thanks",
    removeHeader: (tillNumber: number) => `Remove Assigned Till #${tillNumber}`,
    removeButtonPrompt: (tillNumber: number) => `Remove Till #${tillNumber}`,
    mainPrompt: "Are you sure you want to remove the currently assigned till?",
    subPrompt:
        "Doing so will require you to select a new till before accepting more orders",
};

export default function ManagerRemoveTill() {
    const navigate = useNavigate();
    const {isTraining, setCashierMode} = useContext(StationContext);
    const {
        assignedTill,
        setAssignedTill,
        trainingModeAssignedTill,
        setTrainingModeAssignedTill,
        assigningTill,
        errorMessage,
        clearErrorMessage,
    } = useContext(TillAssignmentContext);

    const currentStationMode = useAppSelector(
        (state) => state.pos.station.mode,
    );

    function navigateToDeviceSetup() {
        navigate(routeHelpers.deviceSetup(), {
            state: {
                skipCCRegistrationCheck:
                    currentStationMode === "drive_thru_order_taker" ||
                    currentStationMode === "line_buster",
            },
        });
        setCashierMode({type: "user"});
    }

    function onClose() {
        navigate(routeHelpers.managerMenu());
    }

    function onRemoveTill() {
        if (isTraining) {
            setTrainingModeAssignedTill(-1);
            navigateToDeviceSetup();
            return;
        }

        setAssignedTill(-1).then(navigateToDeviceSetup);
    }

    return (
        <Drawer onClose={onClose} size="small">
            <div className={styles.header}>
                {strings.removeHeader(
                    isTraining ? trainingModeAssignedTill : assignedTill,
                )}
            </div>
            <div className={styles.bodyContainer}>
                <img className={styles.image} src={tillIcon} alt="" />
                <div className={styles.mainPrompt}>{strings.mainPrompt}</div>
                <div className={styles.subPrompt}>{strings.subPrompt}</div>
                <OutlineButton
                    className={styles.removeButton}
                    label={strings.removeButtonPrompt(
                        isTraining ? trainingModeAssignedTill : assignedTill,
                    )}
                    labelClassName={styles.removeButtonLabel}
                    onClick={onRemoveTill}
                    disabled={assigningTill}
                    mode="blue"
                />
                <TextButton
                    className={styles.noButton}
                    label={strings.no}
                    onClick={onClose}
                    disabled={assigningTill}
                />
            </div>
            {errorMessage ? (
                <ErrorModal
                    errorMessage={errorMessage}
                    onClose={clearErrorMessage}
                    showITInfo
                />
            ) : null}
        </Drawer>
    );
}
